'use client';

import { CartProvider } from './CartProvider';
export default function Providers({
  children
}: {
  children: React.ReactNode;
}) {
  return <>
      <CartProvider data-sentry-element="CartProvider" data-sentry-source-file="index.tsx">{children}</CartProvider>
    </>;
}